import { render } from "./EventTypeListView.vue?vue&type=template&id=ff81cf68&scoped=true"
import script from "./EventTypeListView.vue?vue&type=script&lang=js"
export * from "./EventTypeListView.vue?vue&type=script&lang=js"

import "./EventTypeListView.vue?vue&type=style&index=0&id=ff81cf68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff81cf68"]])

export default __exports__